import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { freeLabelColor } from "../../utils/categoricalColors";

export const DepartmentChip = styled(Chip)({
	borderRadius: "16px",
	height: "24px",
	fontSize: "14px",
	fontWeight: 500,
	padding: "2px 2px",
	border: "none",
	backgroundColor: "var(--inhouse-primary-alpha-08)",
	color: "var(--inhouse-primary-dark)",
	"&.selected": {
		border: "1px solid #4D5579",
		backgroundColor: "var(--inhouse-primary-alpha-08)",
		color: "var(--inhouse-primary-dark)",
		fontWeight: 600,
	},
});

interface IProps {
	stats: Record<string, number>;
	handleSelectDepartment: (department: string) => void;
	selectedDepartment: string;
}

export const DepartmentChips = React.memo(({ stats, handleSelectDepartment, selectedDepartment }: IProps) => {
	return (
		<Box sx={{ mb: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
			{Object.keys(stats).map((department: string) => (
				<DepartmentChip
					key={department}
					label={`${department} (${stats[department]})`}
					className={department === selectedDepartment ? "selected" : ""}
					icon={
						<span
							style={{
								width: 8,
								height: 8,
								borderRadius: "50%",
								backgroundColor: freeLabelColor(department).dot,
							}}
						/>
					}
					onClick={() => handleSelectDepartment(department)}
				/>
			))}
		</Box>
	);
});
